import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { BudgetEntity } from "./budget.entity";
import { DataSource, Not, Repository } from "typeorm";
import { BudgetCostReq, CommonResponseModel } from "@project-management-system/shared-models";
import { ErrorResponse } from "packages/libs/backend-utils/src/models/global-res-object";
import { BudgetDto } from "./budget.dto";



@Injectable()
export class BudgetService {
    constructor(
        @InjectRepository(BudgetEntity)

        private repo: Repository<BudgetEntity>,
        private readonly dataSource: DataSource,

    ) { }

    async createBudget(req: BudgetDto): Promise<CommonResponseModel> {

        try {

            const existingBudget = await this.repo.findOne({ where: { departmentName: req.departmentName, budgetPeriod: req.budgetPeriod, budget: req.budget } });
            if (existingBudget) {
                return new CommonResponseModel(false, 0, 'Department, Budget Period and Budget combination already exists');
            }

            const entity = new BudgetEntity()
            entity.budgetPeriod = req.budgetPeriod;
            entity.fromDate = req.fromDate;
            entity.toDate = req.toDate;
            entity.budget = req.budget;
            entity.departmentName = req.departmentName;
            entity.createdUser = req.createdUser;
            entity.isActive = req.isActive;
            entity.versionFlag = req.versionFlag;
            entity.updatedUser = req.updatedUser;


            if (req.id) {

                entity.updatedUser = req.createdUser

            } else {

                entity.createdUser = req.createdUser
            }
            const save = await this.repo.save(entity)
            if (!save) {

                return new CommonResponseModel(false, 0, 'Something went wrong in Budget creation', [])
            } else {

                return new CommonResponseModel(true, 1, 'Created successfully', save)
            }

        } catch (err) {

            throw err
        }
    }


    async getAllBudget(): Promise<CommonResponseModel> {
        // const data = await this.repo.find()
        const data = `SELECT 
        bud.id AS id,bud.departmentName AS departmentName,
        dep.department_name AS deptName,
        bud.budget_period AS budgetPeriod,
        bud.from_date AS fromDate,
        bud.to_date AS toDate,
        bud.budget AS budget,
        bud.is_active AS isActive,
        bud.version_flag AS versionFlag
    FROM 
        budget bud 
    LEFT JOIN 
        department dep ON bud.departmentName = dep.id;
    `
        const record = await this.dataSource.query(data);

        if (record.length > 0) {
            return new CommonResponseModel(true, 1, 'data retrived Sucessfully', record)
        }
        return new CommonResponseModel(true, 1, 'data retrived Sucessfully', [])
    } catch(err) {
        return err;
    }

    async getActiveAllBudget(): Promise<CommonResponseModel> {
        const data = await this.repo.find({
            where: {
                isActive: true
            }
        })

        if (data.length > 0) {
            return new CommonResponseModel(true, 1, 'data retrived Sucessfully', data)
        }
        return new CommonResponseModel(true, 1, 'data retrived Sucessfully', [])
    }


    async updateBudget(req: BudgetDto): Promise<CommonResponseModel> {
        // console.log("budgetreq======",req);

        try {

            const existingBudget = await this.repo.findOne({
                where: {
                    departmentName: req.departmentName,
                    budgetPeriod: req.budgetPeriod,
                    budget: req.budget,
                    id: Not(req.id),

                },
            });

            if (existingBudget) {
                return new CommonResponseModel(false, 0, 'Budget Name already exists');
            }
            let Product;

            if (req.budgetPeriod === "Monthly") {
                req.toDate = "-";
            }
            Product = await this.repo.update(
                { id: req.id },
                {

                    budgetPeriod: req.budgetPeriod,
                    fromDate: req.fromDate,
                    toDate: req.toDate,
                    budget: req.budget,
                    departmentName: req.departmentName
                }
            )
            if (Product.affected > 0) {
                return new CommonResponseModel(true, 11, 'updated successfully', Product);
            }
            else {
                return new CommonResponseModel(false, 11, 'uploaded failed', []);
            }
        }
        catch (error) {
            console.log(error);
        }
    }

    async activateOrDeactivateBudget(req: BudgetDto): Promise<CommonResponseModel> {
        try {
            // console.log(req.isActive, 'service-----------')
            const Exists = await this.repo.findOne({ where: { id: req.id } });
            if (Exists) {
                if (!Exists) {
                    throw new ErrorResponse(10113, 'Someone updated the current Budget information.Refresh and try again');
                } else {

                    const update = await this.repo.update(
                        { id: req.id },
                        { isActive: req.isActive, updatedUser: req.updatedUser });
                    if (Exists.isActive) {
                        if (update.affected) {
                            const Response: CommonResponseModel = new CommonResponseModel(true, 10115, 'Budget is Deactivated successfully');
                            return Response;
                        } else {
                            throw new CommonResponseModel(false, 10111, 'Budget is already deactivated');
                        }
                    } else {
                        if (update.affected) {
                            const Response: CommonResponseModel = new CommonResponseModel(true, 10114, 'Budget is activated successfully');
                            return Response;
                        } else {
                            throw new CommonResponseModel(false, 10112, 'Budget is already  activated');
                        }
                    }

                }
            } else {
                throw new CommonResponseModel(false, 99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }


    async getBudgetCostReport(req: BudgetCostReq): Promise<CommonResponseModel> {
        let query = `SELECT
        DATE_FORMAT(b.from_date, '%Y') AS YEAR,
        DATE_FORMAT(b.from_date, '%m') AS MONTH,
        b.id,
        b.departmentName,
        d.department_name AS departmentname,
        b.budget_period AS budgetPeriod,
        b.from_date AS fromDate,
        b.to_date AS toDate,
        b.budget,
        vr.cost,
        SUM(b.budget) OVER (PARTITION BY DATE_FORMAT(b.from_date, '%Y-%m'), d.department_name) AS monthlyBudget,
        SUM(vr.cost) OVER (PARTITION BY DATE_FORMAT(b.from_date, '%Y-%m'), d.department_name) AS monthlyCost,
        b.created_at AS createdAt
    FROM
        budget b
    LEFT JOIN 
        vehicle_request vr ON vr.department_id = b.departmentName
    LEFT JOIN
        department d ON d.id = b.departmentName
    WHERE 
        1=1
    `;

        if (req.departmentName) {
            query += ` AND d.department_name = '${req.departmentName}'`;
        }
        if (req.year) {
            query += ` AND DATE_FORMAT(b.from_date, '%Y') = '${req.year}'`;
        }
        query += ` group by d.id`;

        const data = await this.repo.query(query);
        if (data.length > 0) {
            return new CommonResponseModel(true, 1, 'Data retrieved', data);
        } else {
            return new CommonResponseModel(false, 0, 'No data found');
        }
    }

}